// Curated set of 32 glyphs that are widely supported and visually distinct,
// enough for cross-stitch charts that may use 20-30 floss colors.
export const SYMBOLS = [
  "●", "▲", "■", "◆", "★", "✚",
  "✖", "◐", "◑", "▼", "⬢", "✦",
  "◯", "△", "□", "◇", "☆", "▽",
  "⬡", "⊕", "⊗", "⊠", "✱", "✜",
  "♦", "♥", "♣", "♠", "†", "‡",
  "§", "¶",
] as const;

export function symbolFor(index: number): string {
  return SYMBOLS[index % SYMBOLS.length];
}

// Pick a readable foreground color (black or white) for text drawn on top of an
// RGB background, based on perceived luminance.
export function contrastColor(r: number, g: number, b: number): "#000" | "#fff" {
  // Rec. 709 luminance approximation, integer math is fine here.
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance > 0.55 ? "#000" : "#fff";
}
